import {
  CreateFollowUpConfigurationInput,
  UpdateFollowUpConfigurationInput
} from "shared/types/__generated__/graphql"

import { FollowUpConfiguration } from "entities/dim-configuration/types/FollowUpConfiguration"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"
import { useScrollController } from "features/scroll-management/model/useScrollController"

import { FollowUpConfigurationAdminPageView } from "./FollowUpConfigurationAdminPageView"
import { useFollowUpConfigurationAdminPageViewModel } from "./model/useFollowUpConfigurationAdminPageViewModel"

export interface FollowUpConfigurationAdminPageProps {
  followUpConfigurations: FollowUpConfiguration[]
  productOptions: ProductSelectOption[]
  isLoading: boolean
  error?: Error
  isCreating: boolean
  isUpdating: boolean
  isDeleting: boolean
  createConfiguration: (
    input: CreateFollowUpConfigurationInput
  ) => Promise<void>
  updateConfiguration: (
    id: string,
    input: UpdateFollowUpConfigurationInput
  ) => Promise<void>
  deleteConfiguration: (id: string) => Promise<void>
}

export function FollowUpConfigurationAdminPage({
  followUpConfigurations,
  productOptions,
  isLoading,
  error,
  isCreating,
  isUpdating,
  isDeleting,
  createConfiguration,
  updateConfiguration,
  deleteConfiguration
}: FollowUpConfigurationAdminPageProps) {
  useScrollController()

  const viewModel = useFollowUpConfigurationAdminPageViewModel({
    followUpConfigurations,
    createConfiguration,
    updateConfiguration,
    deleteConfiguration
  })

  return (
    <FollowUpConfigurationAdminPageView
      {...viewModel}
      productOptions={productOptions}
      isLoading={isLoading}
      error={error}
      isCreating={isCreating}
      isUpdating={isUpdating}
      isDeleting={isDeleting}
      hasConfigurations={followUpConfigurations.length > 0}
    />
  )
}
